module.exports = __webpack_public_path__ + "assets/img/00042.93708bbb.png";